var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textarea"},[_c('div',{staticClass:"label-float"},[_c('textarea',_vm._g(_vm._b({ref:"textarea",class:`${!!_vm.design ? `design-${_vm.design}` : ''} ${
        _vm.noResize ? 'resize-none' : ''
      }`,style:(_vm.minHeight ? `min-height: ${_vm.minHeight}px` : ''),attrs:{"id":_vm.id,"placeholder":_vm.label,"maxlength":_vm.maxLength},domProps:{"value":_vm.value}},'textarea',_vm.$attrs,false),_vm.inputListeners)),_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }